export enum TaghvimSaleSakhtEnum {
  Shamsi = 0,
  Miladi = 1,
}
